 <template>
  <div class="info-region-container">
    <div
      class="all-content-container"
      v-allow="'0604'"
      style="margin: 0 auto; width: 100%"
    >
      <div class="container1">
        <div class="titlemaun" style="">
          <div style="padding: 15px; border: ">
            <h3>{{ deviceSwitchName }} - 局部控制设备</h3>
          </div>
          <div class="table-title-btn">
            <el-button type="primary" class="adduser" @click="handleAdd"
              >添加</el-button
            >
            <el-button type="primary" class="adduser" @click="handleReturn"
              >返回环境控制设备</el-button
            >
          </div>
        </div>
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item>
            <el-button type="primary" class="button" @click="handleSearch"
              >查询</el-button
            >
            <el-button type="button" ass="button" @click="handleRest"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div class="info-content-container">
        <div class="table_content1" style="margin-top: 10px">
          <el-table
            :data="tableData"
            align="center"
            class="data-table"
            v-loading="loading"
            style="width: 100%"
            :header-cell-style="{ background: '#F4F5F7' }"
          >
            <el-table-column align="center" label="设备类型">
              <template slot-scope="scope">
                <p v-if="scope.row.deviceType == 0">电阀门</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="设备名称">
              <template slot-scope="scope">
                <p>{{ scope.row.switchName }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="属性名称">
              <template slot-scope="scope">
                <p>{{ scope.row.switchAttrName }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="开关开度">
              <template slot-scope="scope">
                <p>{{ scope.row.opening }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="环境传感器">
              <template slot-scope="scope">
                <p>{{ scope.row.numericalName }}</p>
              </template>
            </el-table-column>
            <el-table-column fixed="right" align="center" label="操作">
              <template slot-scope="scope">
                <el-button
                  @click="handleEdit(scope.row)"
                  type="text"
                  size="small"
                  >编辑</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="handleDel(scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination-container">
          <div class="page"></div>
          <div class="pagination-content-container">
            <el-pagination
              background
              layout="prev, pager, next, jumper"
              class="pageTap"
              @current-change="handleCurrentChange"
              :current-page="searchForm.pageNum"
              :page-size="searchForm.pageSize"
              :total="total"
            ></el-pagination>
          </div>
        </div>
        <el-dialog
          :title="addEditTitle"
          :visible.sync="addEditIsDialog"
          :before-close="handleCancel"
          width="600px"
          center
          style="z-index: 10000"
        >
          <el-form
            ref="ruleForm"
            :rules="rules"
            :model="ruleForm"
            label-width="120px"
            class="demo-ruleForm"
          >
            <el-row>
              <el-col :span="24">
                <el-form-item label="设备类型：" prop="deviceType">
                  <el-select
                    v-model="ruleForm.deviceType"
                    placeholder="请选择设备类型"
                    clearable
                  >
                    <el-option label="电阀门" value="0"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="设备属性：" prop="deviceAttributeId">
                  <el-select
                    v-model="ruleForm.deviceAttributeId"
                    placeholder="请选择设备属性"
                    clearable
                    @change="deviceAttributeChange"
                  >
                    <el-option
                      v-for="item in deviceAttributeArray"
                      :key="item.deviceId + ',' + item.attributeId"
                      :label="item.deviceName + '_' + item.attributeName"
                      :value="item.deviceId + ',' + item.attributeId"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- <el-row>
              <el-col :span="24">
                <el-form-item label="设备名称：" prop="switchId">
                  <el-select
                    v-model="ruleForm.switchId"
                    placeholder="请选择设备名称"
                    clearable
                    @change="deviceChange"
                  >
                    <el-option
                      v-for="item in deviceArray"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="属性名称：" prop="switchAttrId">
                  <el-select
                    v-model="ruleForm.switchAttrId"
                    placeholder="请选择属性名称"
                    clearable
                    @change="attributeChange"
                  >
                    <el-option
                      v-for="item in attributeArray"
                      :key="item.id"
                      :label="item.cname"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row> -->
            <el-row>
              <el-col :span="24">
                <el-form-item label="开关开度：" prop="opening">
                  <el-input-number
                    v-model="ruleForm.opening"
                    placeholder="请输入开关开度"
                    :min="0"
                    :max="100"
                    :precision="0"
                    :step="1"
                    size="small"
                    :disabled="!isOpening"
                  ></el-input-number>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="环境传感器：" prop="integerList">
                  <el-select
                    v-model="ruleForm.integerList"
                    placeholder="请选择环境传感器"
                    multiple
                    collapse-tags
                    clearable
                  >
                    <el-option
                      v-for="item in deviceNumericalArray"
                      :key="item.id"
                      :label="item.numericalName + '_' + item.numericalAttrName"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="handleCancel">取 消</el-button>
            <el-button type="primary" @click="handleSave">确 定</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      searchForm: {
        // 查询条件表单字段
        pageNum: 1,
        pageSize: 10,
        deviceSwitchId: "",
      },
      total: 0, // 总条数
      tableData: [], // 表格数据
      loading: false, // 表格加载中是否显示
      ruleForm: {
        // 添加编辑表单字段
        id: "",
        deviceSwitchId: "",
        deviceType: "",
        switchId: "",
        switchAttrId: "",
        opening: "",
        integerList: [],
        deviceAttributeId: "",
      },
      rules: {
        // 添加编辑表单规则
        deviceType: [
          {
            required: true,
            message: "请选择设备类型",
            trigger: "change",
          },
        ],
        deviceAttributeId: [
          {
            required: true,
            message: "请选择设备属性",
            trigger: "change",
          },
        ],
        // switchId: [
        //   {
        //     required: true,
        //     message: "请选择设备名称",
        //     trigger: "change",
        //   },
        // ],
        // switchAttrId: [
        //   {
        //     required: true,
        //     message: "请选择属性名称",
        //     trigger: "change",
        //   },
        // ],
        opening: [
          {
            required: true,
            message: "请输入开关开度",
            trigger: "blur",
          },
        ],
        integerList: [
          {
            required: true,
            message: "请选择环境传感器",
            trigger: "change",
          },
        ],
      },
      deviceSwitchId: "", // 环境控制设备ID
      deviceSwitchName: "", // 控制控制设备名称
      addEditTitle: "添加局部控制设备", // 添加编辑弹窗标题
      addEditIsDialog: false, // 添加编辑弹窗是否显示
      isOpening: false, // 是否可以填写开度，仅仅模拟开关可以填写，其它默认0
      deviceArray: [], // 设备数组
      attributeArray: [], // 属性数组
      deviceNumericalArray: [], // 环境传感器数组
      deviceAttributeArray: [], // 设备属性数组
    };
  },
  created() {
    this.searchForm.deviceSwitchId = this.$route.query.deviceSwitchId;
    this.ruleForm.deviceSwitchId = this.$route.query.deviceSwitchId;
    this.deviceSwitchId = this.$route.query.deviceSwitchId;
    this.deviceSwitchName = this.$route.query.deviceSwitchName;

    // 查询
    this.getList();

    // 获取大棚设备标签列表
    this.getControlDevices();

    // 获取环境传感器列表
    this.getDeviceNumericalList();

  },
  methods: {
    // 查询
    handleSearch() {
      this.searchForm.pageNum = 1;
      this.getList();
    },
    // 重置
    handleRest() {
      this.searchForm = {
        pageNum: 1,
        pageSize: 10,
        deviceSwitchId: this.deviceSwitchId,
      };
      this.getList();
    },
    // 分页查询
    handleCurrentChange: function (currentPage) {
      this.searchForm.pageNum = currentPage;
      this.getList();
    },
    // 分页获取列表
    getList() {
      this.loading = true;
      this.$api.growthModel
        .getGrowthModelDeviceSwitchSecondList(this.searchForm)
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
            this.total = res.count;
            this.loading = false;
          }
        });
    },
    // 删除
    handleDel(row) {
      this.$confirm("是否删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$api.growthModel
            .delGrowthModelDeviceSwitchSecond(row.id)
            .then((res) => {
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: res.msg,
                });
                this.getList();
              }
            });
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    // 编辑
    handleEdit(row) {
      this.addEditIsDialog = true;
      this.addEditTitle = "编辑局部控制设备";
      this.ruleForm.id = row.id;
      this.ruleForm.deviceSwitchId = this.deviceSwitchId;

      // 获取详情
      this.$api.growthModel
        .getGrowthModelDeviceSwitchSecond({ id: row.id })
        .then((res) => {
          if (res.code == 200) {
            res.data.deviceType =
              res.data.deviceType != undefined
                ? res.data.deviceType.toString()
                : "";
            res.data.deviceAttributeId =
              res.data.switchId + "," + res.data.switchAttrId;
            res.data.integerList =
              res.data.integerList != undefined ? res.data.integerList : [];
            this.ruleForm = res.data;
          }
        });
    },
    // 添加
    handleAdd() {
      this.addEditIsDialog = true;
      this.addEditTitle = "添加局部控制设备";
      this.ruleForm.id = "";
      this.ruleForm.deviceSwitchId = this.deviceSwitchId;
    },
    // 取消
    handleCancel() {
      this.$refs["ruleForm"].resetFields();
      this.addEditIsDialog = false;
    },
    // 保存
    handleSave() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.$api.growthModel
            .saveGrowthModelDeviceSwitchSecond(this.ruleForm)
            .then((res) => {
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: res.msg,
                });
                this.handleCancel();
                this.handleSearch();
              }
            });
        }
      });
    },
    // 返回
    handleReturn() {
      this.$router.push({
        name: `growthModelParamDeviceManagement`,
        query: {
          paramId: this.$route.query.paramId,
          paramType: this.$route.query.paramType,
          paramName: this.$route.query.paramName,
          paramUnit: this.$route.query.paramUnit,
          evnId: this.$route.query.evnId,
          evnName: this.$route.query.evnName,
          groupId: this.$route.query.groupId,
          controlType: this.$route.query.controlType,
          currentShow: "second",
        },
      });
    },
    // 获取设备列表
    getDeviceList() {
      this.$api.device
        .getAllDeviceSwitchs({ groupId: this.$route.query.groupId })
        .then((res) => {
          if (res.code == 200) {
            this.deviceArray = res.data;
          }
        });
    },
    // 设备下拉切换
    deviceChange() {
      this.ruleForm.switchAttrId = "";
      this.attributeArray = [];
      this.isOpening = false;
      this.ruleForm.opening = 0;

      // 获取属性列表
      this.getAttributeList();
    },
    // 获取属性列表
    getAttributeList() {
      this.$api.device
        .getAttributesBySwtichId(this.ruleForm.switchId)
        .then((res) => {
          if (res.code == 200) {
            this.attributeArray = res.data;

            // 属性下拉切换
            this.attributeChange();
          }
        });
    },
    // 属性下拉切换
    attributeChange() {
      if (this.ruleForm.switchAttrId === "") {
          return;
      }

      // 获取开关类型
      var switchType = -1;
      if (this.ruleForm.switchAttrId) {
        this.attributeArray.forEach((val) => {
          if (val.id == this.ruleForm.switchAttrId) {
            switchType = val.switchType;
            return;
          }
        });
      }

      if (switchType == 1 || switchType == 4) {
        this.isOpening = true;
      } else {
        this.isOpening = false;
        this.ruleForm.opening = 0;
      }

    },
    // 获取环境传感器列表
    getDeviceNumericalList() {
      this.$api.growthModel
        .getGrowthModelDeviceNumericalAll({
          paramId: this.$route.query.paramId,
        })
        .then((res) => {
          if (res.code == 200) {
            this.deviceNumericalArray = res.data;
          }
        });
    },
    // 获取大棚设备标签列表
    getControlDevices() {
      this.$api.growthModel
        .getControlDevices({
          type: 3,
          deviceSign: this.$route.query.paramType,
          groupId: this.$route.query.groupId,
        })
        .then((res) => {
          if (res.code == 200) {
            this.deviceAttributeArray = res.data;
          }
        });
    },
    // 设备属性下拉切换
    deviceAttributeChange() {
      if (this.ruleForm.deviceAttributeId) {
        let arr = this.ruleForm.deviceAttributeId.split(",");
        this.ruleForm.switchId = arr[0];
        this.ruleForm.switchAttrId = arr[1];
      } else {
        this.ruleForm.switchId = "";
        this.ruleForm.switchAttrId = "";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.container1 {
  border: 1px solid rgba(232, 232, 232, 1);
}

.el-button {
  line-height: 0;
}

.all-content-container {
  width: 100%;
}

.titlemaun {
  display: flex;
  justify-content: space-between;
  height: 48px;
  border-bottom: 1px solid #ededed;
  border-top: 1px solid #ededed;
  margin-top: 1px;
}

h4 {
  font-size: 14px;
  font-weight: 550;
  color: #000;
  height: 48px;
  line-height: 48px;
  padding-left: 18px;
}

.demo-ruleForm {
  width: 95%;
  margin: 0 auto;
  padding-top: 10px;

  .el-row {
    margin-bottom: 20px;
  }

  .el-select {
    width: 100% !important;
  }

  .el-input-number {
    width: 100% !important;
  }
}
</style>